import gsap from 'gsap';
import $ from 'jquery';

window.addEventListener('keydown', () =>
  setTimeout(() => {
    document.body.classList.add('-key-after-mouse');
  }, 50)
);

window.addEventListener('mousedown', () =>
  setTimeout(() => {
    document.body.classList.remove('-key-after-mouse');
  }, 50)
);

initRipples();

export default function initRipples() {
  $(document.body).on('focus', '.ripple', e => {
    const b = e.currentTarget;

    if (!b.querySelector('.ripple__wave')) {
      const r = document.createElement('div');
      r.className = 'ripple__wave';
      b.appendChild(r);
    }
  });

  $(document.body).on('mousedown', '.ripple', e => {
    // left click only
    if (e.button !== 0) {
      return;
    }

    const b = e.currentTarget;
    const centered = b.classList.contains('ripple--centered');
    const r = document.createElement('div');
    r.className = 'ripple__wave';
    b.appendChild(r);

    if (e.currentTarget.closest('[disabled]')) {
      return;
    }

    const { top, left, height, width } =
      e.currentTarget.getBoundingClientRect();

    const coords = centered
      ? null
      : {
          top: e.clientY - top,
          left: e.clientX - left
        };

    const fromCenter = centered
      ? 0
      : Math.sqrt(
          Math.abs(coords.top - height / 2) ** 2 +
            Math.abs(coords.left - width / 2) ** 2
        );

    const diagonal = Math.sqrt(height ** 2 + width ** 2);

    const scale = centered ? 1 : diagonal / (diagonal - fromCenter);
    // console.log('c', fromCenter, diagonal, scale);

    gsap
      .timeline()
      .fromTo(
        r,
        {
          scale: 0,
          opacity: 1,
          ...coords,
          transition: 'none',
          animation: 'none'
        },
        {
          scale,
          ease: 'expo-out',
          clearProps: 'all',
          duration: 1
        }
      )
      .to(r, { opacity: 0, onComplete: () => r.remove() }, '-=0.5');
  });
}
